// import ModalForm from "./Form";
import FeesNoticeDetailsDeductionsTableFormVoucher from "./FeesNoticeDetailsDeductionsTableFormVoucher";
import {
	INVOICE_FEE_V2,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const FeesNoticesDetailsDeductionsTableSchema = {
	components: { FeesNoticeDetailsDeductionsTableFormVoucher },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: INVOICE_FEE_V2,
			tableId: "fees-notice-details-deductions-table",
			formId: "fees-notice-details-deductions-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Product Name",
					type: "custom-html",
					key: "product_id",
					modifier: (value) => {
						return value.name
					}
				},
                {
					title: "Quantity",
					type: "text",
					key: "qty",
				},
                {
					title: "Unit Price",
					type: "custom-html",
					key: "price",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
                {
					title: "Amount",
					type: "custom-html",
					key: "amount",
					titleAlignment: "right",
					modifier: (value) => {
						return `<div style="text-align: right;">${this.formattedIDR(value)}</div>`;
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "FeesNoticeDetailsDeductionsTable",
				url: INVOICE_FEE_V2 + "?is_deduction=yes&invoice_id=" + this.invoiceRequestId,
				showHeader: true,
				enableHighlights: false,
				enableSaveFilter: false,
				enableRowSelect: false,
				columns: [],
				actions: [
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
                        disabled: (rowData) => this.isButtonDisabled(rowData),
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: false,
				showClearFilter: false,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat('id-ID', {
				style: 'currency',
				currency: 'IDR',
				minimumFractionDigits: 0
			}).format(value);
		},
        isButtonDisabled(rowData) {
            // console.log('isButtonDisabled:', rowData);
            return rowData.status?.toLowerCase() === "deleted";// || (rowData.deduction_type?.toLowerCase() === 'voucher');
        },
	},
};
